import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { Dep } from '../class/auth';

@Component({
  selector: 'app-live',
  templateUrl: './live.component.html',
  styleUrls: ['./live.component.css']
})
export class LiveComponent implements OnInit {

  time :any={};
  tool_obj:any={search_model:'',receive_status:'-1',flag:-1}
  sort_obj:any = {column:'create_dt',sort:'0'}
  data:any=[];
  detail_info:any=[];
  time_info:any=70;
  link:string = environment.link;
  edit_data:any=[]
  preurl :string = '';
  urltoken :string = '';
  loading:boolean=true;
  pageobj:page = {page:0,count:12,total_count:0};
  menu_list:menulist = [{id:'1',name:'當前直播'},{id:'2',name:'直播紀錄'}];
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  now:string = '1';


  receive_option_list:menulist=[
    {id:'-2',name:'全部'},
    {id:'-1',name:'樁腳'},
    {id:'0',name:'不收回'},
  ];


  constructor(
    public httpClient: HttpClient,
  ) { }

  ngOnInit(): void {
    this.count_time();
    this.init_list();
  }


  count_time(){
    clearTimeout(this.tool_obj.flag);
    this.tool_obj.flag = window.setTimeout(()=>{
      this.time_info--;
      if(this.time_info==0  && this.now== '1'){
        this.init_list();
      }else{
        this.count_time();
      }
      console.log(123);
    },1000)
  }

  init_list(){
    this.time_info = 70;
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,action:this.now,tool:this.tool_obj,sort_obj:this.sort_obj};
    this.httpClient.post<any>("/customer_service/get_live_list.php",body).subscribe(res => {
      this.loading = false;
      this.data = res.data
      this.pageobj.total_count = res.total_count
      if(res.status ){
        this.count_time();
      }
      console.log(res);
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    }, error => {
      console.log(error);
    });
  }
  view_it(item,action){
    this.edit_data = item;
    this.loading = true;
    const body = {data:item ,action:action,tool:this.tool_obj};
    this.httpClient.post<any>("/customer_service/live_detail_action.php",body).subscribe(res => {
      this.loading = false;
      if(action==0){
        this.detail_info = res.data
      }else{
        if(res.status){
          alert('成功');
        }else{
          alert(res.msg);
        }
        this.init_list();
      }
      console.log(res);
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    }, error => {
      console.log(error);
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }


  choose(value:string){
    this.now = value;
    this.tool_obj.search_model = '';
    this.init_list();
  }

  sort_fn(key,can_sort=1){
    if(can_sort){
      if(key==this.sort_obj.column){
        this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
      }else{
        this.sort_obj.column = key;
        this.sort_obj.sort = '0';
      }
      this.init_list(); 
    }
  }

}
